/** サイドバー: タブ ID → 親グループ ID */
export const TAB_TO_GROUP = {
  clinics: 'account',
  users: 'account',
  roles: 'account',
  licenses: 'product',
  'health-check': 'product',
  products: 'product',
  'invitation-rewards': 'product',
  accounting: 'accounting',
  announcements: 'operations',
  inquiries: 'operations',
  legal: 'operations',
  'hp-management': 'operations',
  'email-settings': 'operations',
  logs: 'admin',
  allowlist: 'admin',
  settings: 'admin',
  notifications: 'admin',
};

export function getAdminNavGroups() {
  return [
    {
      id: 'account',
      label: 'アカウント',
      items: [
        { id: 'clinics', label: 'クリニック管理' },
        { id: 'users', label: 'ユーザー管理' },
        { id: 'roles', label: 'ロール設定' },
      ],
    },
    {
      id: 'product',
      label: 'プロダクト',
      items: [
        { id: 'health-check', label: 'ヘルスチェック' },
        { id: 'licenses', label: 'ライセンス管理' },
        { id: 'products', label: 'プロダクト管理' },
        { id: 'invitation-rewards', label: '招待特典' },
      ],
    },
    {
      id: 'accounting',
      label: '会計',
      items: [
        { id: 'accounting', label: 'Stripe明細' },
      ],
    },
    {
      id: 'operations',
      label: '運営',
      items: [
        { id: 'announcements', label: 'お知らせ管理' },
        { id: 'inquiries', label: 'お問い合わせ' },
        { id: 'email-settings', label: 'メール送信設定' },
        { id: 'legal', label: '規約改定' },
        { id: 'hp-management', label: 'HP管理' },
      ],
    },
    {
      id: 'admin',
      label: '管理',
      items: [
        { id: 'logs', label: 'ログ' },
        { id: 'allowlist', label: 'ログイン許可' },
        { id: 'settings', label: 'ハブ設定' },
        { id: 'notifications', label: '通知設定' },
      ],
    },
  ];
}
